module.exports = "https://static.moomoo.com/components/common-redpacket/images/no-crowd.15b995ab06.png";